export const partners = [
  {
    name: 'Airbnb',
    logo: 'https://assets.maccarianagency.com/the-front/logos/airbnb.svg',
  },
  {
    name: 'Coinbase',
    logo: 'https://assets.maccarianagency.com/the-front/logos/coinbase.svg',
  },
  {
    name: 'Dribbble',
    logo: 'https://assets.maccarianagency.com/the-front/logos/dribbble.svg',
  },
  {
    name: 'Instagram',
    logo: 'https://assets.maccarianagency.com/the-front/logos/instagram.svg',
  },
  {
    name: 'Netflix',
    logo: 'https://assets.maccarianagency.com/the-front/logos/netflix.svg',
  },
  {
    name: 'Pinterest',
    logo: 'https://assets.maccarianagency.com/the-front/logos/pinterest.svg',
  },
];

export const services = [
  {
    icon: 'fas fa-laptop-code',
    title: 'Web Design',
    description:
      'We design and develop beautiful, lightning fast, scalable, and marketing-focused websites tailored to grow your business.',
  },
  {
    icon: 'fas fa-mobile-alt',
    title: 'UI / UX Design',
    description:
      'We craft great user centered interfaces for web and mobile apps. We ensure to deliver intuitive and seamless experiences.',
  },
  {
    icon: 'far fa-lightbulb',
    title: 'Product Design',
    description:
      'We help you to carefully improve your digital product to deliver a great user experience, grow its user base and increase retention.',
  },
  {
    icon: 'fas fa-brain',
    title: 'Branding',
    description:
      'We transform businesses into brands through high quality brand identity design.',
  },
  {
    icon: 'fas fa-rocket',
    title: 'Optimization',
    description:
      'We help you optimize your website or mobile app to increase your conversion rates.',
  },
  {
    icon: 'fas fa-cogs',
    title: 'Automation',
    description:
      'We help your business gain leverage and efficiency through smart automation.',
  },
];

export const process = [
  {
    icon: 'fas fa-brain',
    title: '1. Idea',
    description:
      'We meet with your team to know more about your idea, project and goal. After that, our team sits to create an action plan and proposal for your project.',
  },
  {
    icon: 'fas fa-mobile-alt',
    title: '2. Design',
    description:
      'We start by designing a mockup or prototype of your website/app, and present it to you. Once with the initial mockup, we start the revision process to perfect it.',
  },
  {
    icon: 'fas fa-laptop-code',
    title: '3. Development',
    description:
      'We develop your website using the best practices and standards, so you have a perfectly responsive, lightning fast, and super scalable website.',
  },
  {
    icon: 'fas fa-cogs',
    title: '4. Launch & Maintenance',
    description:
      'When the project is ready, we help you to launch it and push it live. After that, we meet with your team to train them on how to edit, update and scale it.',
  },
];

export const work = [
  {
    title: 'Your Brand Platform',
    description:
      'Monetize your website and manage all guest interactions with your own brand, logo and domains.',
    illustration: 'https://assets.maccarianagency.com/the-front/illustrations/brand-platform.svg',
  },
  {
    title: 'Mobile Compatible Platform',
    description:
      'Introduce your brand-new mobile friendly website to your customers. Seamlessly integrates with WiFi hardware and marketing automation software.',
    illustration: 'https://assets.maccarianagency.com/the-front/illustrations/mobiles.svg',
  },
  {
    label: 'CLIENT PORTAL ACCESS',
    title: 'Simple Customer Dashboards',
    description:
      'Give sub-users access to a simplified dashboard with limited permission levels to offer remote management and real-time analytics.',
    illustration: 'https://assets.maccarianagency.com/the-front/illustrations/dashboard.svg',
  },
];

export const reviews = [
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams@2x.jpg 2x',
    },
    authorName: 'Veronica Adams',
    authorOccupation: 'Growth Marketer, Crealytics',
    feedback:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini@2x.jpg 2x',
    },
    authorName: 'Akachi Luccini',
    authorOccupation: 'Lead Generation, Alternative Capital',
    feedback:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  },
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith@2x.jpg 2x',
    },
    authorName: 'Jack Smith',
    authorOccupation: 'Head of Operations, Parkfield Commerce',
    feedback:
      'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  },
];
